<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12">
        <v-card>
          <v-card-title>
            <v-icon left>
              {{ icons.mdiQrcode }}
            </v-icon>
            打刻QRコード
          </v-card-title>

          <v-card-subtitle>
            キャストがこのQRコードをスキャンして出退勤を記録します
          </v-card-subtitle>

          <v-card-text>
            <!-- ローディング -->
            <div
              v-if="loading"
              class="text-center py-8"
            >
              <v-progress-circular
                indeterminate
                color="primary"
              />
              <p class="mt-2">
                読み込み中...
              </p>
            </div>

            <!-- エラー -->
            <v-alert
              v-else-if="error"
              type="error"
              outlined
            >
              {{ error }}
              <template #append>
                <v-btn
                  text
                  small
                  @click="fetchToken"
                >
                  再試行
                </v-btn>
              </template>
            </v-alert>

            <!-- QRコード表示 -->
            <div
              v-else
              class="d-flex flex-column align-center"
            >
              <div class="qr-wrapper elevation-2 mb-4">
                <canvas id="punch-qr-code" />
              </div>

              <p class="text-h4 font-weight-bold mb-2">
                {{ currentTime }}
              </p>
              <p class="text-h6 mb-4">
                {{ currentDate }}
              </p>

              <div class="text-center">
                <p class="text-body-1 mb-1">
                  営業日: <strong>{{ punchDate }}</strong>
                </p>
                <p class="text-caption grey--text">
                  有効期限: {{ expiresAt }}
                </p>
              </div>

              <v-btn
                class="mt-4"
                color="primary"
                outlined
                @click="fetchToken"
              >
                <v-icon left>
                  {{ icons.mdiRefresh }}
                </v-icon>
                更新
              </v-btn>
            </div>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import {
  ref, onMounted, onBeforeUnmount, nextTick,
} from '@vue/composition-api'
import QrCode from 'qrcode'
import { mdiQrcode, mdiRefresh } from '@mdi/js'
import CastAppPunchTokenApi from '@/api/admin/CastAppPunchToken'

export default {
  name: 'PunchQrCode',

  setup() {
    const loading = ref(true)
    const error = ref(null)
    const punchDate = ref('')
    const expiresAt = ref('')
    const currentDate = ref('')
    const currentTime = ref('')
    let timerId = null

    const updateClock = () => {
      const now = new Date()
      currentDate.value = now.toLocaleDateString('ja-JP', {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
        weekday: 'short',
      })
      currentTime.value = now.toLocaleTimeString('ja-JP', {
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
      })
    }

    const generateQrCode = qrPayload => {
      const canvas = document.getElementById('punch-qr-code')
      if (canvas) {
        QrCode.toCanvas(canvas, qrPayload, {
          width: 300,
          margin: 2,
        }, err => {
          if (err) console.error('QRコード生成エラー:', err)
        })
      }
    }

    const fetchToken = async () => {
      loading.value = true
      error.value = null
      try {
        const response = await CastAppPunchTokenApi.getToday()
        const { data } = response
        punchDate.value = data.date
        expiresAt.value = new Date(data.expires_at).toLocaleString('ja-JP')

        loading.value = false
        await nextTick()
        generateQrCode(data.qr_payload)
      } catch (e) {
        error.value = '打刻トークンの取得に失敗しました'
        loading.value = false
      }
    }

    onMounted(() => {
      updateClock()
      timerId = setInterval(updateClock, 1000)
      fetchToken()
    })

    onBeforeUnmount(() => {
      if (timerId) clearInterval(timerId)
    })

    return {
      loading,
      error,
      punchDate,
      expiresAt,
      currentDate,
      currentTime,
      fetchToken,
      icons: {
        mdiQrcode,
        mdiRefresh,
      },
    }
  },
}
</script>

<style scoped>
.qr-wrapper {
  display: inline-flex;
  padding: 16px;
  background: white;
  border-radius: 8px;
}
</style>
